import { render, staticRenderFns } from "./editPrivacySetting.vue?vue&type=template&id=5b151d86"
import script from "./editPrivacySetting.vue?vue&type=script&lang=js"
export * from "./editPrivacySetting.vue?vue&type=script&lang=js"
import style0 from "./editPrivacySetting.vue?vue&type=style&index=0&id=5b151d86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports